import ChooseAvatar from './ChooseAvatar'

export default ChooseAvatar



// WEBPACK FOOTER //
// ./src/app/modules/ChooseAvatar/index.js